import { render, staticRenderFns } from "./ManagingAttorney.vue?vue&type=template&id=7fd2816e&scoped=true&"
import script from "./ManagingAttorney.vue?vue&type=script&lang=js&"
export * from "./ManagingAttorney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd2816e",
  null
  
)

export default component.exports